import channel from './modules/channel'

// A Vuex instance is created by combining the state, the actions,
// and the mutations. Because the actions and mutations are just
// functions that do not depend on the instance itself, they can
// be easily tested or even hot-reloaded (see counter-hot example).

const state = {
  isLogged: !!localStorage.getItem('token')
}

const mutations = {
  LOGIN_USER (state) {
    state.isLogged = true
  },

  LOGOUT_USER (state) {
    state.isLogged = false
  }
}

export default {
  modules: {
    channel
  },
  strict: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/store.js